import { render, staticRenderFns } from "./q4.vue?vue&type=template&id=40a97096&scoped=true"
import script from "./q4.vue?vue&type=script&lang=js"
export * from "./q4.vue?vue&type=script&lang=js"
import style0 from "./q4.vue?vue&type=style&index=0&id=40a97096&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a97096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a97096')) {
      api.createRecord('40a97096', component.options)
    } else {
      api.reload('40a97096', component.options)
    }
    module.hot.accept("./q4.vue?vue&type=template&id=40a97096&scoped=true", function () {
      api.rerender('40a97096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q4.vue"
export default component.exports